import React from 'react';

const Facebook: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="none" {...props}>
    <path
      fill="#5067A5"
      d="M19.81 45V27.11H14V20h5.81v-5.602C19.81 8.313 23.418 5 28.683 5c2.523 0 4.69.195 5.318.281v6.36H30.35c-2.864 0-3.417 1.406-3.417 3.46V20h6.462l-.886 7.11h-5.576V45"
    ></path>
  </svg>
);

export default Facebook;
